import { createContext, lazy, Suspense, useContext, useEffect, type ComponentType, type ReactNode } from 'react';
import { configurarToken, MODO_MOCK } from './api/transporte';
import { Cargando } from './componentes/ui';

export type ModoSesion = 'mock' | 'dev' | 'clerk';

export interface Sesion {
  modo: ModoSesion;
  /** Selector de organización + usuario (sólo con Clerk). */
  Controles: ComponentType | null;
}

const CtxSesion = createContext<Sesion>({ modo: 'dev', Controles: null });
export const useSesion = () => useContext(CtxSesion);
export const ProveedorCtxSesion = CtxSesion.Provider;

export const CLAVE_CLERK = (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined)?.trim() || '';

const SesionClerk = lazy(() => import('./sesionClerk'));

function SesionLocal({ modo, children }: { modo: ModoSesion; children: ReactNode }) {
  useEffect(() => { configurarToken(async () => 'dev'); }, []);
  return <CtxSesion.Provider value={{ modo, Controles: null }}>{children}</CtxSesion.Provider>;
}

export function ProveedorSesion({ children }: { children: ReactNode }) {
  if (MODO_MOCK) return <SesionLocal modo="mock">{children}</SesionLocal>;
  if (!CLAVE_CLERK) return <SesionLocal modo="dev">{children}</SesionLocal>;
  return (
    <Suspense fallback={<Cargando texto="Abriendo sesión…" />}>
      <SesionClerk clave={CLAVE_CLERK}>{children}</SesionClerk>
    </Suspense>
  );
}
